module.exports = "/images/starMetiers.svg?fb458f761d21790be7bb803dbe336722";